import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  qrContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    display: 'flex',
    backgroundColor: theme.palette.black.main,
    justifyContent: 'center',
    zIndex: 1,
  },
  qrIcon: {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
    marginBottom: theme.spacing(1),
  },
}));
